import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchMyOrganizationsCount, fetchMySourcesCount, } from "../api/usersService";
export var useMyData = function (userId) {
    var ky = useOkapiKy();
    var _a = useQuery(["myOrganizationsCount", userId], function () { return fetchMyOrganizationsCount(ky); }, {
        enabled: !!userId,
    }), userOrganizationsCount = _a.data, isOrganizationsCountLoading = _a.isLoading, isOrganizationsCountError = _a.isError, organizationsCountError = _a.error;
    var _b = useQuery(["mySourcesCount", userId], function () { return fetchMySourcesCount(ky); }, {
        enabled: !!userId,
    }), userSourcesCount = _b.data, isSourcesCountLoading = _b.isLoading, isSourcesCountError = _b.isError, sourcesCountError = _b.error;
    return {
        countsLoading: isOrganizationsCountLoading || isSourcesCountLoading,
        canEditEmail: (userOrganizationsCount !== null && userOrganizationsCount !== void 0 ? userOrganizationsCount : 0) <= 1 && (userSourcesCount !== null && userSourcesCount !== void 0 ? userSourcesCount : 0) <= 1,
        isCountsError: isOrganizationsCountError || isSourcesCountError,
        organizationsCountError: organizationsCountError,
        sourcesCountError: sourcesCountError,
    };
};
